import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './image-hotspot-panel.scss.js';

class ImageHotspotPanel extends s {
    constructor() {
        super(...arguments);
        this.convatecData = {
            title: '',
            img: '',
            overview: '',
            objListData: [],
        };
        this.expandedIndex = -1;
        this.currentCarouselIndex = 0;
        this.scale = 1;
        this.isDragging = false;
        this.showPanelDescription = false;
        this.isMobileOrTablet = false;
        this.prevScale = 1;
        this.startX = 0;
        this.startY = 0;
        this.imagePosX = 0;
        this.imagePosY = 0;
        this.prevStyle = '';
        this.swipeStartX = 0;
        this.resizeObserver = null;
    }
    _handleSwipeStart(e) {
        this.swipeStartX = e.touches[0].clientX;
    }
    _handleSwipeEnd(e) {
        const swipeEndX = e.changedTouches[0].clientX;
        const swipeDistance = swipeEndX - this.swipeStartX;
        if (Math.abs(swipeDistance) > 50) {
            if (swipeDistance < 0) {
                this._nextImage();
            }
            else {
                this._prevImage();
            }
        }
    }
    firstUpdated() {
        const defaultIndex = this.convatecData.objListData.findIndex(item => item.productId === '0');
        if (defaultIndex !== -1) {
            this.expandedIndex = defaultIndex;
        }
        this._observeContainerSize();
        if (this.convatecData.objListData.length > 0) {
            this._handleHotspotClick(0);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this._updateDeviceType();
        window.addEventListener('resize', this._updateDeviceType.bind(this));
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        window.removeEventListener('resize', this._updateDeviceType.bind(this));
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    _observeContainerSize() {
        var _a;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.module');
        if (!container)
            return;
        this.resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const { width } = entry.contentRect;
                this.isMobileOrTablet = width <= 839;
                this.requestUpdate();
            }
        });
        if (container) {
            this.resizeObserver.observe(container);
        }
    }
    _updateDeviceType() {
        const width = window.innerWidth;
        this.isMobileOrTablet = width <= 839;
    }
    _handleHotspotClick(index) {
        this.expandedIndex = index;
        if (this.isMobileOrTablet) {
            const container = this.shadowRoot.querySelector('.image-container');
            this.prevStyle = container.style.cssText;
            this.showPanelDescription = true;
            this._scrollToPanelView();
        }
    }
    _scrollToPanelView() {
        const panelContainer = this.shadowRoot.querySelector('.panels');
        setTimeout(() => {
            panelContainer === null || panelContainer === void 0 ? void 0 : panelContainer.focus();
            panelContainer === null || panelContainer === void 0 ? void 0 : panelContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        }, 100);
    }
    _goBackToImage(e) {
        e.preventDefault();
        this.showPanelDescription = false;
        const container = this.shadowRoot.querySelector('.image-container');
        if (this.prevStyle) {
            container.style.cssText = this.prevStyle;
        }
    }
    _zoomIn() {
        if (this.scale < 1.8) {
            this.scale = Math.min(this.scale + 0.2, 1.8);
            this._applyZoomAndDrag();
        }
    }
    _zoomOut() {
        if (this.scale > 1) {
            this.scale = Math.max(this.scale - 0.2, 1);
            if (this.scale === 1) {
                this.imagePosX = 0;
                this.imagePosY = 0;
            }
            this._applyZoomAndDrag();
        }
    }
    _applyZoomAndDrag() {
        const container = this.shadowRoot.querySelector('.image-container');
        container.style.transform = `scale(${this.scale}) translate(${this.imagePosX}px, ${this.imagePosY}px)`;
    }
    _startDragging(e) {
        const startX = e instanceof TouchEvent ? e.touches[0].clientX : e.clientX;
        const startY = e instanceof TouchEvent ? e.touches[0].clientY : e.clientY;
        if (this.scale > 1) {
            this.isDragging = true;
            this.startX = startX - this.imagePosX;
            this.startY = startY - this.imagePosY;
            const image = this.shadowRoot.querySelector('.image-container img');
            if (image && image instanceof HTMLElement)
                image.style.cursor = 'grabbing';
        }
    }
    _stopDragging() {
        this.isDragging = false;
        const image = this.shadowRoot.querySelector('.image-container img');
        if (image && image instanceof HTMLElement)
            image.style.cursor = this.scale > 1 ? 'grab' : 'default';
    }
    _drag(e) {
        if (this.isDragging) {
            const currentX = e instanceof TouchEvent ? e.touches[0].clientX : e.clientX;
            const currentY = e instanceof TouchEvent ? e.touches[0].clientY : e.clientY;
            const newX = currentX - this.startX;
            const newY = currentY - this.startY;
            this.imagePosX = newX;
            this.imagePosY = newY;
            this._applyZoomAndDrag();
        }
    }
    _renderHotspots() {
        return this.convatecData.objListData.map((item, index) => {
            const left = item.handPositionLeft;
            const top = item.handPositionTop;
            const isActive = index === this.expandedIndex;
            return $ `
        <a
          href="#"
          class="hotspot ${isActive ? 'active' : ''}"
          data-initial-left="${left}"
          data-initial-top="${top}"
          style="left: ${left}%; top: ${top}%"
          aria-label="${item.title}"
          @click="${(e) => {
                e.preventDefault();
                this._handleHotspotClick(index);
            }}"
        >
        </a>
      `;
        });
    }
    _nextImage() {
        const mediaItems = this.convatecData.objListData[this.expandedIndex].listVideoOrImage;
        if (this.currentCarouselIndex < mediaItems.length - 1) {
            this.currentCarouselIndex += 1;
        }
        else {
            this.currentCarouselIndex = 0;
        }
    }
    _prevImage() {
        const mediaItems = this.convatecData.objListData[this.expandedIndex].listVideoOrImage;
        if (this.currentCarouselIndex > 0) {
            this.currentCarouselIndex -= 1;
        }
        else {
            this.currentCarouselIndex = mediaItems.length - 1;
        }
    }
    _goToImage(index) {
        this.currentCarouselIndex = index;
    }
    _renderPanels() {
        return this.convatecData.objListData.map((item, index) => {
            const isActive = index === this.expandedIndex;
            const mediaItems = item.listVideoOrImage;
            const hasMediaItems = mediaItems && mediaItems.length > 0;
            const isCarousel = hasMediaItems && mediaItems.length > 1;
            const title = $ `<h4 class="panel-title">${item.title}</h4>`;
            return $ `
        <div class="panel ${isActive ? 'active' : ''}">
          ${title}

          <div class="description panel-title-image">
            ${this._renderDescription(item.description)}
          </div>

          ${(() => {
                if (!hasMediaItems)
                    return '';
                if (isCarousel)
                    return this._renderCarousel(mediaItems);
                return this._renderSingleItem(mediaItems[0]);
            })()}
        </div>
      `;
        });
    }
    _renderSingleItem(mediaItem) {
        return $ `
      <div class="single-item-carousel">
        ${this._renderMedia(mediaItem)}
        <p>${mediaItem.description}</p>
      </div>
    `;
    }
    _renderDescription(description) {
        const div = document.createElement('div');
        div.innerHTML = description;
        return div;
    }
    _renderCarousel(mediaItems) {
        return $ `
      <div
        class="carousel"
        @touchstart="${this._handleSwipeStart}"
        @touchend="${this._handleSwipeEnd}"
      >
        <button @click="${this._prevImage}" class="arrow-left">⟨</button>
        <div
          class="carousel-container"
          style="transform: translateX(${-this.currentCarouselIndex * 100}%);"
        >
          ${this._renderImageOrVideo(mediaItems)}
        </div>
        <button @click="${this._nextImage}" class="arrow-right">⟩</button>
      </div>

      <div class="carousel-dots">${this._renderDots(mediaItems)}</div>
    `;
    }
    _renderImageOrVideo(mediaItems) {
        return mediaItems.map(media => $ `
        <div class="carousel-slide">
          <div class="carousel-slide-item">${this._renderMedia(media)}</div>
          <p>${media.description}</p>
        </div>
      `);
    }
    _renderMedia(mediaItem) {
        return mediaItem.isVideo
            ? $ `
          <video-block alignment="none">
            <img
              src="${mediaItem.imageSource}"
              alt="${mediaItem.imgAltText}"
              slot="thumbnail"
            />
            <video-player
              slot="inline-video"
              videoId="${mediaItem.videoSource}"
              type="Local"
              usedInInline
            >
            </video-player>
          </video-block>
        `
            : $ `<img
          src="${mediaItem.imageSource}"
          alt="${mediaItem.imgAltText}"
        />`;
    }
    _renderDots(mediaItems) {
        return mediaItems.map((_, i) => $ `
        <span
          class="dot ${this.currentCarouselIndex === i ? 'active' : ''}"
          tabindex="0"
          @click="${() => this._goToImage(i)}"
          @keydown="${(e) => this._handleKeydown(e, i)}"
        >
        </span>
      `);
    }
    _handleKeydown(e, index) {
        if (e.key === 'Enter' || e.key === ' ') {
            this._goToImage(index);
        }
    }
    render() {
        var _a;
        const renderBigScreensPanel = () => $ `<div class="panels">${this._renderPanels()}</div>`;
        const renderPanel = () => $ `
        <div class="image-wrapper">
          <div class="wrapper">
            <div
              class="image-container"
              @mousedown="${this._startDragging}"
              @mouseup="${this._stopDragging}"
              @mousemove="${this._drag}"
              @touchstart="${this._startDragging}"
              @touchend="${this._stopDragging}"
              @touchmove="${this._drag}"
            >
              <img
                src="${this.convatecData.img}"
                alt="${this.convatecData.title || 'Image Title'}"
                style="width: 100%; height: auto;"
              />
              ${this._renderHotspots()}
            </div>
          </div>
          <div class="zoom-controls">
            <button
              @click="${this._zoomOut}"
              class="zoom-out"
              ?disabled="${this.scale <= 1}"
            >
              -
            </button>
            <button
              @click="${this._zoomIn}"
              class="zoom-in"
              ?disabled="${this.scale >= 1.8}"
            >
              +
            </button>
          </div>
        </div>
        ${renderBigScreensPanel()}
      `;
        const titleHeader = ((_a = this.convatecData.title) === null || _a === void 0 ? void 0 : _a.trim())
            ? $ `<h3>${this.convatecData.title}</h3>`
            : '';
        return $ `
      <div class="module">
        <div class="header">
          ${titleHeader}
          <p class="product-overview-link">${this.convatecData.overview}</p>
        </div>
        <div class="container">${renderPanel()}</div>
      </div>
    `;
    }
}
ImageHotspotPanel.styles = css_248z;
__decorate([
    e({ type: Object })
], ImageHotspotPanel.prototype, "convatecData", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "expandedIndex", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "currentCarouselIndex", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "scale", void 0);
__decorate([
    e({ type: Boolean })
], ImageHotspotPanel.prototype, "isDragging", void 0);
__decorate([
    e({ type: Boolean })
], ImageHotspotPanel.prototype, "showPanelDescription", void 0);
__decorate([
    e({ type: Boolean })
], ImageHotspotPanel.prototype, "isMobileOrTablet", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "prevScale", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "startX", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "startY", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "imagePosX", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "imagePosY", void 0);
__decorate([
    e({ type: String })
], ImageHotspotPanel.prototype, "prevStyle", void 0);
__decorate([
    e({ type: Number })
], ImageHotspotPanel.prototype, "swipeStartX", void 0);
customElements.define('image-hotspot-panel', ImageHotspotPanel);

export { ImageHotspotPanel };
